import { useEffect } from "react";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/admin/AdminShell";

export const Route = createFileRoute("/_authenticated/admin")({
  head: () => ({ meta: [{ title: "Admin — Medical Insight" }] }),
  component: AdminLayout,
});

function AdminLayout() {
  // Pin the fixed admin theme (html[data-admin-theme] in styles.css) for the
  // whole /admin subtree. On <html> rather than a wrapper because portalled
  // UI (dialogs, selects, toasts) renders outside this component's DOM.
  useEffect(() => {
    document.documentElement.setAttribute("data-admin-theme", "");
    return () => document.documentElement.removeAttribute("data-admin-theme");
  }, []);

  return (
    <AdminShell>
      <Outlet />
    </AdminShell>
  );
}
